export const PermissionSuperAdminRead = 'admin:read';
export const PermissionSuperAdminWrite = 'admin:write';
